import OrganisationsTeamsGridRow from "../components/OrganisationsTeamsGridRow";

const OrganisationsTeamsGridContainer = (props) => {
    const teams = props.teams;

    return (
        <div className="organisations-teams-grid-container">
            {teams && teams.map((team) => {
                return <OrganisationsTeamsGridRow team={team} handleClick={props.handleClick} key={team && team.id}/>
            })}
        </div>
    )
}
export default OrganisationsTeamsGridContainer;